import { NoticeBanner } from "./NoticeBanner.js";
import styles from "./NoticesBanner.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function NoticesBanner({
  notices,
  onClose
}) {
  return /*#__PURE__*/_jsx("div", {
    className: styles.noticesBanner,
    children: notices.map(notice => /*#__PURE__*/_jsx(NoticeBanner, {
      notice: notice,
      onClose: () => {
        onClose?.(notice.id);
      }
    }, notice.id))
  });
}